<template>
	<div style="min-height:100%" class="d-flex">
		<ChamaileonCard footerless>
			<ChamaileonFlagToast
				uid="ssoRegistrationError"
			/>
			<div v-if="isLoading" class="pa-6">
				<v-progress-circular
					:size="50"
					:width="5"
					color="primary"
					indeterminate
				/>
			</div>
		</ChamaileonCard>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "SSO",
	data() {
		return {
			isLoading: true,
		};
	},
	computed: {
		...mapState({
			queryParams: state => state.queryParams,
		}),
	},
	async mounted() {
		try {
			if (!this.queryParams.state) throw new Error("oAuthStateError");
			if (this.queryParams.error || this.queryParams.error_description) {
				const descriptionExists = !!this.queryParams.error_description;
				throw new Error(descriptionExists ? this.queryParams.error_description : this.queryParams.error);
			}

			this.$store.commit("setUpAccount/SET_SSO_CODE", this.queryParams.code || null);

			let decoded;
			let parsed;
			try {
				decoded = decodeURIComponent(this.queryParams.state);
				parsed = JSON.parse(decoded);
			} catch (error) {
				decoded = null;
				throw error;
			}

			const { oAuthState, registrationToken } = parsed || {};
			this.$store.commit("setUpAccount/SET_OAUTH_STATE", oAuthState || null);
			this.$store.commit("setUpAccount/SET_REGISTRATION_TOKEN", registrationToken || null);
			if (this.queryParams.code || this.queryParams.state) {
				await this.$store.dispatch("setUpAccount/ssoGetTokensForRegistration");
				return;
			}
		} catch (error) {
			this.isLoading = false;
			this.$store.dispatch("sso/displayErrorOnSSO", error);
		}
	},
};
</script>
